import {
  USER_EXISTS_4D,
  USER_EXISTS_MYSQL,
  PRACT_LOGGED_IN,
  PRACT_LOGGED_OUT,
  GET_PATIENTS,
  GET_LAST_TEN_RESULTS,
  CLEAR_LAST_RESULST,
  ALL_PATIENT_ORDERS,
  PATIENT_ORDER_RESULTS,
  PATIENT_ORDER_RESULTS_ONE,
  PATIENT_HISTORIC,
  CLEAR_ALL_PATIENT_ORDERS,
  CLEAR_PATIENT_ORDER_RESULTS,
  //CLEAR_PATIENT_ORDER_RESULTS_ONE,
  CLEAR_PATIENT_HISTORIC,
  PRACTITIONER_INFO,
  SELECTED_PATIENT,
  CLEAR_SELECTED_PATIENT,
  ALL_PRACTITIONERS,
  SELECTED_PRACTITIONER,
  CLEAR_SELECTED_PRACTITIONER,
  CLEAR_PRACTITIONER_INFO,
  ALL_ENTITIES,
  ENTITY_INFO,
  SELECTED_ENTITY,
  CLEAR_SELECTED_ENTITY,
  CLEAR_ENTITY_INFO,
  ALL_PASSWORD_CONFIGURATIONS
} from "../types";

export function practitioner(state = {}, action = {}) {
  switch (action.type) {
    case PRACT_LOGGED_IN:
      return action.practitioner;

    case PRACT_LOGGED_OUT:
      return {};
    default:
      return state;
  }
}

export function practitionerInfo(state = {}, action = {}) {
  switch (action.type) {
    case PRACTITIONER_INFO:
      return action.practitionerInfo;
    case CLEAR_PRACTITIONER_INFO:
      return action.practitionerInfo;
    default:
      return state;
  }
}

export function entityInfo(state = {}, action = {}) {
  switch (action.type) {
    case ENTITY_INFO:
      return action.entityInfo;
    case CLEAR_ENTITY_INFO:
      return action.entityInfo;
    default:
      return state;
  }
}

export function allPractitionersStore(state = {}, action = {}) {
  switch (action.type) {
    case ALL_PRACTITIONERS:
      return action.allPractitioners;
    default:
      return state;
  }
}

export function allPasswordConfigurationsStore(state = {}, action = {}) {
  switch (action.type) {
    case ALL_PASSWORD_CONFIGURATIONS:
      return action.allPasswordConfigurations;
    default:
      return state;
  }
}

export function allEntitiesStore(state = {}, action = {}) {
  switch (action.type) {
    case ALL_ENTITIES:
      return action.allEntities;
    default:
      return state;
  }
}

export function user4D(state = {}, action = {}) {
  switch (action.type) {
    case USER_EXISTS_4D:
      return action.user4D;
    default:
      return state;
  }
}

export function user(state = {}, action = {}) {
  switch (action.type) {
    case USER_EXISTS_MYSQL:
      return action.user;
    default:
      return state;
  }
}

export function patients(state = {}, action = {}) {
  switch (action.type) {
    case GET_PATIENTS:
      return action.patients;
    default:
      return state;
  }
}

export function lastTenResults(state = {}, action = {}) {
  switch (action.type) {
    case GET_LAST_TEN_RESULTS:
      return action.results;
    case CLEAR_LAST_RESULST:
      return action.results;
    default:
      return state;
  }
}

export function allPatientOrders(state = {}, action = {}) {
  switch (action.type) {
    case ALL_PATIENT_ORDERS:
      return action.orders;
    case CLEAR_ALL_PATIENT_ORDERS:
      return action.orders;
    default:
      return state;
  }
}
export function patientOrderResults(state = {}, action = {}) {
  switch (action.type) {
    case PATIENT_ORDER_RESULTS:
      return action.orderResults;
    case PATIENT_ORDER_RESULTS_ONE:
      return action.orderResults;
    case CLEAR_PATIENT_ORDER_RESULTS:
      return action.orderResults;
    default:
      return state;
  }
}
/*export function patientOrderResultsOne(state = {}, action = {}) {
  switch (action.type) {
    case PATIENT_ORDER_RESULTS_ONE:
      return action.orderResults;
    case CLEAR_PATIENT_ORDER_RESULTS:
      return action.orderResults;
    default:
      return state;
  }
}*/
export function patientHistoric(state = {}, action = {}) {
  switch (action.type) {
    case PATIENT_HISTORIC:
      return action.historic;
    case CLEAR_PATIENT_HISTORIC:
      return action.historic;
    default:
      return state;
  }
}

export function selectedPatient(state = {}, action = {}) {
  switch (action.type) {
    case SELECTED_PATIENT:
      return action.selected_patient;
    case CLEAR_SELECTED_PATIENT:
      return action.selected_patient;
    default:
      return state;
  }
}

export function selectedPractitioner(state = {}, action = {}) {
  switch (action.type) {
    case SELECTED_PRACTITIONER:
      return action.data;
    case CLEAR_SELECTED_PRACTITIONER:
      return action.data;
    default:
      return state;
  }
}

export function selectedEntity(state = {}, action = {}) {
  switch (action.type) {
    case SELECTED_ENTITY:
      return action.data;
    case CLEAR_SELECTED_ENTITY:
      return action.data;
    default:
      return state;
  }
}
